var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3636 4.94925L5.23287 12.9521L3.11339 13.5211L1 14.0902L1.55423 12.0056L2.11455 9.92107L10.4402 1.72656",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36719 17H12.6399",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 1.65081C10.6476 1.44782 10.8806 1.28571 11.1386 1.17397C11.3965 1.06224 11.6742 1.00313 11.9553 1.00012C12.2364 0.997109 12.5152 1.05025 12.7755 1.15643C13.0358 1.26261 13.2723 1.4197 13.471 1.61847C13.6698 1.81724 13.8269 2.0537 13.9331 2.31398C14.0392 2.57426 14.0924 2.85312 14.0894 3.13421C14.0864 3.4153 14.0273 3.69297 13.9155 3.95091C13.8038 4.20886 13.6416 4.4419 13.4387 4.63636",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f82c5624a3c09f4f9ac383d015ede08f.svg";
export { ForwardRef as ReactComponent };